// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Luna Point 2
 * Service Luna Point 2
 * Version: v.0.0.0
 */
export type StreamTargetsParameterItem = typeof StreamTargetsParameterItem[keyof typeof StreamTargetsParameterItem];


export const StreamTargetsParameterItem = {
  stream_id: 'stream_id',
  account_id: 'account_id',
  name: 'name',
  description: 'description',
  data: 'data',
  location: 'location',
  permission_tag: 'permission_tag',
  create_time: 'create_time',
  last_error: 'last_error',
  groups: 'groups',
  status: 'status',
  splittable: 'splittable',
  analytics: 'analytics',
} as const;
